module.exports = __webpack_public_path__ + "img/xukezheng2.b859be0e.jpg";